import { type ReactNode } from "react";

import clsx from "clsx";

import { GenericExternalLink } from "@components/generic-external-link";
import { useUser } from "@components/user-context";
import { prettyLogEvent } from "@internal/analytics";
import { Pages } from "@north-beam/nb-client-side/constants";

export function BenchmarksLearnMore({ className }: { className?: string }) {
  return (
    <div className={className}>
      Want to learn more? Click{" "}
      <a
        href="https://docs.northbeam.io/docs/sales-page#benchmarking-tool"
        target="_blank"
        rel="noreferrer"
        className="text-primary cursor-pointer underline underline-offset-2"
      >
        here
      </a>{" "}
      for the Benchmarks Knowledge Base
    </div>
  );
}

export const BENCHMARK_HELP_LINK =
  "https://www.northbeam.io/submit-a-support-ticket";
export const BenchmarkHelpWidget = ({
  className,
  size = "sm",
}: {
  className?: string;
  size?: "sm" | "xs";
}) => {
  const { user } = useUser();

  return (
    <div
      className={clsx(className, {
        "text-xs lg:text-sm": size === "sm",
        "text-xs": size === "xs",
      })}
    >
      <span className="font-semibold">Need help creating your benchmarks?</span>
      <span className="md:text-xs lg:text-sm">
        {" "}
        Submit a request to our support team{" "}
        <GenericExternalLink
          className="text-primary cursor-pointer underline underline-offset-2"
          href={BENCHMARK_HELP_LINK}
          onClick={() => {
            prettyLogEvent.navigateToPage({
              user,
              page: Pages.SALES,
              domain: "Benchmarking - Help Modal",
            });
          }}
        >
          here
        </GenericExternalLink>
      </span>
      <BenchmarksLearnMore className="text-xs lg:text-sm" />
    </div>
  );
};

export const BenchmarkHelpFooter = ({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) => (
  <div
    className={clsx(
      className,
      "w-full border-t pt-4 bg-white flex justify-between items-center",
    )}
  >
    <BenchmarkHelpWidget className="flex-grow" />
    {children}
  </div>
);
